const API_URL = process.env.REACT_APP_API_URL || '';

/**
 * 공급사 정보 조회
 * @returns {Promise<{ name, representative, businessNumber, commerceNumber, address, phone, email }>}
 */
export const getCompanyInfo = async () => {
    const res = await fetch(`${API_URL}/api/config/company`);
    if (!res.ok) throw new Error('Failed to fetch company info');
    return res.json();
};

/**
 * 견적서 조건 조회
 * @returns {Promise<{ validityDays, deliveryTerms, paymentTerms }>}
 */
export const getEstimateTerms = async () => {
    const res = await fetch(`${API_URL}/api/config/estimate-terms`);
    if (!res.ok) throw new Error('Failed to fetch estimate terms');
    return res.json();
};
